import React, { useState, useCallback } from "react";
import { Card } from "./Card";
// import update from "immutability-helper";

export const Container = (props) => {
  const initialState = props.children.map((Component, index) => ({
    id: index,
    Component,
  }));

  const { onMove } = props;
  const [cards, setCards] = useState(initialState);
  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      const dragCard = cards[dragIndex];
      const newCards = [...cards];
      newCards.splice(dragIndex, 1);
      newCards.splice(hoverIndex, 0, dragCard);
      setCards(newCards);
      onMove(newCards);
    },
    [cards, onMove]
  );
  const renderCard = (card, index) => {
    return (
      <Card
        key={card.id}
        index={index}
        id={card.id}
        Component={card.Component}
        moveCard={moveCard}
      />
    );
  };
  return (
    <>
      <div className="drag-container">
        {cards.map((card, i) => renderCard(card, i))}
      </div>
    </>
  );
};

export default Container;
